import ClientJourneyBroadcastMessaging from './ClientJourneyBroadcastMessaging';

export default ClientJourneyBroadcastMessaging;
